<template>
  <div class="classifyCatalog">
    <div v-if="login">
      <scroll-view :scroll="true" class="left">
        <div
          v-for="(item,index) in list"
          :key="index"
          @click="()=>tebIndex = index"
          :style="{color:tebIndex == index? 'red':'#000'}"
        >
          <div style="transform:scale(0.9)">{{item.name}}</div>
        </div>
      </scroll-view>
      <scroll-view :scroll="true" class="right">
        <div v-if="list" class="rightdiv">
          <div
            v-for="(infoItem, itemIndex) in list[tebIndex].pic_list"
            :key="itemIndex"
            style="width: 48%;"
            @click="moreTap(infoItem)"
          >
            <goods-view
              :key="itemIndex"
              :item="infoItem"
              :goodsobject="{ list:  list[tebIndex].pic_list, index: itemIndex }"
              :close="false"
              :tapStop="false"
              style="width: 100%;"
            ></goods-view>
          </div>
        </div>
      </scroll-view>
    </div>
    <div v-else>
      <loadMore :loadingType="1" style="width: 100%;"></loadMore>
    </div>
  </div>
</template>

<script>
import { AlbumframegetEffectFrame } from '@/request/api.js'

export default {
  data () {
    return {
      login: true,
      list: null,
      tebIndex: 0
    }
  },
  created () {
    this.AlbumframegetEffectFrame_onLoad()
  },
  methods: {
    moreTap (infoItem) {
      this.$api.commit('attribute', infoItem)
      this.$router.push({
        path: `/classifyCatalog/upload`,
      })
    },
    async AlbumframegetEffectFrame_onLoad () {
      let res = await AlbumframegetEffectFrame('')
      this.list = res.data.map(itemData => {
        itemData.pic_list = itemData.pic_list.map(item => {
          item.image_text = item.aliyun_url
          item.prefix_title = item.mark_word
          return item
        })
        return itemData
      })
      this.login = true
    }
  }
};
</script>

<style lang="less">
.classifyCatalog {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  .left {
    width: 6.5rem;
    height: 100%;
    padding: 0 0.3rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    div {
      font-size: 1rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      text-align: center;
      padding: 1rem 0;
    }
  }
  .right {
    flex: 1;
    height: calc(100% - 6rem);
    padding: 1rem;
    padding-bottom: 1rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .rightdiv {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
  > div {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
  }
  .good-view-text {
    width: calc(100% - 0.2rem) !important;
    font-size: 0.5rem !important;
    margin: 0.1rem !important;
    transform-origin: left;
  }
}
</style>
